module.exports = __webpack_public_path__ + "static/media/logo-light.7beb4315.png";